import React, { useEffect, useState } from 'react'
import loadingGif from '../../../../assets/images/Innobo-Hub-loading.gif';
import Swal from 'sweetalert2'

interface props {
    loading:boolean
    cancelFetch?: Function
    title?:string
    avoidSwalInFirstRender?: any

}



const Iloading = ({loading,cancelFetch,title="Loading data",avoidSwalInFirstRender=false}:props) => {

    const styles = {
        cancelButton: {
            color: 'white',
            padding: '5px 50px',
            borderRadius: '5px',
            cursor: 'pointer',
            fontSize: '16px',
            width: '120px',
            height: '35px',
            paddingLeft: '35px',
            marginTop: '-20px',
        }
    };

    const [firstRender,setFirstRender] = useState(0)

    useEffect(()=>{
        if(avoidSwalInFirstRender && firstRender <= 2){
            setFirstRender(firstRender+1)
        }else{
            if(loading){
                const brandLocalS = JSON.parse(localStorage.getItem('brand') || '');
                Swal.fire({
                   title: `${title}`,
                   backdrop: true,
                   width: 500,
                   allowEscapeKey: false,
                   showCancelButton: cancelFetch ? true:false,
                   allowOutsideClick: false,
                   timerProgressBar: true,
                   allowEnterKey: false,
                   html: `<div style="display: flex; justify-content: center; align-items: center;">
                     <img src="${brandLocalS.urlLoading ?? loadingGif}" alt="Loading..." style="width:100px; margin: 20px;" />
                     </div>`,
                   didOpen: () => {
                       const confirmButton = Swal.getConfirmButton();
                   if (confirmButton) {
                       confirmButton.style.display = 'none';
                   }
                   const cancelButton = Swal.getCancelButton();
                   if (cancelButton) {
                       Object.assign(cancelButton.style, styles.cancelButton);
                   }
                   },
                   customClass: {
                       popup: 'my-swal-popup',
                       cancelButton: 'my-swal-cancelButton'
                     }
               }).then((result) => {
                   if (result.dismiss === Swal.DismissReason.timer) {
                       console.log('I was closed by the timer');
                   }
                   if(result.dismiss === Swal.DismissReason.cancel && cancelFetch){
                       cancelFetch()
                   }
               });
   
           }else{
               Swal.close();
           }
        }


    },[loading])




  return (
    <></>
  )
}

export default Iloading